<div class="row">
  @if (!rentalServiceRequested) {
    <div class="row bottom-dashed-border pad-bottom-20">
      <div class="margin-bottom-30" [innerHTML]="rentalNoSelectionMessage"></div>
    </div>
  } @else {
    <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
      <div class="float-left">
        <strong dsContent [contentPath]="'claims.carReturnLocationText'"></strong>
      </div>
      <div class="float-right">
        <div>{{ serviceRequestPartnerData.serviceRequestPartnerName }}</div>
        <div>
          <span>{{ serviceRequestPartnerData.businessAddress.addressLine1 }}</span> <br />
          <span>{{ serviceRequestPartnerData.businessAddress.city }}</span>
          <span>{{
            serviceRequestPartnerData.businessAddress.state
              ? ', ' + serviceRequestPartnerData.businessAddress.state
              : ''
          }}</span>
          <span> {{ serviceRequestPartnerData.businessAddress.zipCode }}</span>
        </div>
        <div>{{ serviceRequestPartnerData.phoneNumber | prettyPhoneNumber }}</div>
      </div>
    </div>
  }
  @if (rentalCoverage) {
    <div class="row pad-bottom-20 pad-top-20">
      <div class="float-left">
        <strong dsContent [contentPath]="'claims.rentalLimitsText'"></strong>
      </div>
      <div class="float-right">
        {{ claimRentalCarData?.rentalLimits?.perDay }} <br />
        {{ claimRentalCarData?.rentalLimits?.perWeek }}
      </div>
    </div>
  }
</div>
